import { render, staticRenderFns } from "./FacebookConnect.vue?vue&type=template&id=5c091dbd&"
import script from "./FacebookConnect.vue?vue&type=script&lang=js&"
export * from "./FacebookConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports